import { mount } from "@vue/test-utils";
import SelectOption from "@/components/core/custom/SelectOption";

describe("SelectOption test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(SelectOption);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component SelectOption", () => {
    expect(wrapper).toBeDefined();
  });
});
